<div *ngIf="dataService.restaurant && dataService.locale; else loading">
  <!-- Ссылка заведения (slug, id) на широком экране — десктоп-меню для просмотра -->
  <app-desktop-menu *ngIf="desktop && !dataService.restaurant.suspended; else mobile"></app-desktop-menu>

  <ng-template #mobile>
  <!-- Ограничиваем ширину контейнера -->
  <div class="container" #container>
    <!-- Аккаунт заведения удалён (ждёт окончательного удаления) — меню
         недоступно, заказы и вызовы закрыты правилами -->
    <div class="menu-unavailable" *ngIf="dataService.restaurant.suspended">
      <h1 class="menu-unavailable__title">{{ 'menuUnavailable' | translate }}</h1>
      <p class="menu-unavailable__text">{{ 'menuUnavailableText' | translate }}</p>
    </div>

    <ng-container *ngIf="!dataService.restaurant.suspended">
    <!-- Логотип и строка поиска -->
    <app-menu-header-image></app-menu-header-image>

    <!-- Заголовок ресторана -->
    <app-restaurant-title></app-restaurant-title>

    <!-- Аллергия: сообщить официанту (если в меню указаны аллергены) -->
    <app-allergy-notice></app-allergy-notice>

    <!-- Слайдер с событиями -->
    <app-menu-event-slider></app-menu-event-slider>

    <!-- Навигация -->
    <app-menu-navigation></app-menu-navigation>

    <!-- Блок Новинки -->
    <app-category-premiere></app-category-premiere>

    <!-- Категории -->
    <app-menu-categories></app-menu-categories>

    <!-- Промо-заведение (стола у него нет): «Это ваше заведение?» — в конце меню -->
    <app-menu-promo-swipe *ngIf="dataService.restaurant.promo === true"></app-menu-promo-swipe>
    </ng-container>

    <!-- Валидатор для IntersectionObserver -->
    <div class="sentinel-placeholder" #sentinel></div>

    <!-- Подвал. У промо-заведения его нет: реквизиты текущего аккаунта, а не
         будущего владельца, а место под вызов официанта не нужно — стола нет -->
    <app-menu-footer *ngIf="!dataService.restaurant.suspended && dataService.restaurant.promo !== true"></app-menu-footer>
  </div>

  <ng-container *ngIf="!dataService.restaurant.suspended">

  <!-- Поиск по меню — поверх меню, под корзиной -->
  <app-menu-search *ngIf="menuSearch.open$ | async"></app-menu-search>

  <!-- Корзина и заказ — только со столом (QR или демо) -->
  <ng-container *ngIf="dataService.canOrder()">
  <app-menu-basket></app-menu-basket>
  <app-menu-order></app-menu-order>
  </ng-container>

  <!-- Уведомления -->
  <app-menu-notification></app-menu-notification>

  <!-- Вызов официанта -->
  <app-waiter-call></app-waiter-call>
  </ng-container>
  </ng-template>
</div>

<ng-template #loading>
  <div class="loading-indicator"></div>
</ng-template>
